<ng-container *ngIf="variant === 'horizontal-style-1'">
    <navbar-horizontal-style-1></navbar-horizontal-style-1>
</ng-container>

<ng-container *ngIf="variant === 'vertical-style-1'">
    <!-- <navbar-vertical-style-1></navbar-vertical-style-1>
     -->
    <div class="mat-sidenav-left">
        <div fxLayoutAlign="center center" style="width: 100%; padding-top: 30px;" fxHide fxShow.gt-xs>
            <div class="logo ml-4 finance-exhange-column-custom">
                <img class="logo-icon" src="assets/new-dashboard/syndifi-logo-white.svg">
            </div>
        </div>
        <div class="side-left">
            <button (click)="onMenuChange('dashboard')"
                [class]="menuValue === 'dashboard' ? 'button-side-left-active' : 'button-side-left'" mat-button>
                <img class="img-menu"
                    [src]="menuValue === 'dashboard' ? 'assets/new-dashboard/dashboard.svg' : 'assets/new-dashboard/dashboard-inactive.svg'">
                <a routerLink="/apps/dashboard">
                    Dashboard
                </a>
            </button>
            <div *ngIf="this.currentUser['UserDetails'].UserTypeID !== 2">
                <button (click)="onMenuChange('individual')"
                    [class]="menuValue === 'individual' ? 'button-side-left-active' : 'button-side-left'" mat-button>
                    <img class="img-menu"
                        [src]="menuValue === 'individual' ? 'assets/new-dashboard/individual-deals.svg' : 'assets/new-dashboard/individual-deals-inactive.svg'">
                    <a routerLink="/apps/deals">Individual Deals</a>
                </button>
                <button (click)="onMenuChange('deal')"
                    [class]="menuValue === 'deal' ? 'button-side-left-active' : 'button-side-left'" mat-button>
                    <img class="img-menu"
                        [src]="menuValue === 'deal' ? 'assets/new-dashboard/deal-pools.svg' : 'assets/new-dashboard/deal-pools-inactive.svg'">
                    <a routerLink="/apps/deal-pools">Deal
                        Pools</a>
                </button>
                <!-- *ngIf="currentUser && currentUser.UserDetails.UserTypeID != 5" -->
                <button [matMenuTriggerFor]="menu2" (click)="onMenuChange('reports')"
                    [class]="menuValue === 'reports' ? 'button-side-left-active' : 'button-side-left'" mat-button>
                    <img class="img-menu"
                        [src]="menuValue === 'reports' ? 'assets/new-dashboard/reports.svg' : 'assets/new-dashboard/reports-inactive.svg'">
                    <a>Reports</a>
                </button>
                <mat-menu #menu2="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item routerLink="/apps/report">
                        <span class="material-icons icodsign">
                            {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'date_range':
                            ''}}
                        </span>
                        <span class="h4 dtext"> {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Individual Deal Reports':
                            ''}}
                        </span>
                    </button>
                    <button mat-menu-item routerLink="/apps/deal-pool-report">
                        <span class="material-icons icodsign">
                            {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'date_range':
                            ''}}
                        </span>
                        <span class="h4 dtext"> {{ (currentUser == null) ||!currentUser.switchUserprofile &&
                            [8,9,10].indexOf(currentUser.UserDetails.UserTypeID) != -1 ? 'Deal Pool Reports':
                            ''}}
                        </span>
                    </button>
                </mat-menu>
                <button (click)="onMenuChange('buyers')" routerLink="/apps/deal-pool-report"
                    [class]="menuValue === 'buyers' ? 'button-side-left-active' : 'button-side-left'" mat-button>
                    <img class="img-menu"
                        [src]="menuValue === 'buyers' ? 'assets/new-dashboard/buyers.svg' : 'assets/new-dashboard/buyers-inactive.svg'">
                    <a routerLink="/apps/contacts">Buyers</a>
                </button>
                <button (click)="onMenuChange('message')" routerLink="/apps/contacts"
                    [class]="menuValue === 'message' ? 'button-side-left-active' : 'button-side-left'" mat-button>
                    <img class="img-menu"
                        [src]="menuValue === 'message' ? 'assets/new-dashboard/message.svg' : 'assets/new-dashboard/message-inactive.svg'">
                    <a routerLink="/apps/chats">Message</a>
                </button>
                <button (click)="onMenuChange('documentsigned')" routerLink="/apps/documentsigned"
                    [class]="menuValue === 'documentsigned' ? 'button-side-left-active' : 'button-side-left'"
                    mat-button>
                    <img style="width: 25px; height: 25px;padding-right: 0px;" class="img-menu"
                        [src]="menuValue === 'documentsigned' ? 'assets/new-dashboard/document-signed-inactive.svg' : 'assets/new-dashboard/document-signed.svg' ">
                    <a style="padding-left: 3px;" routerLink="/apps/documentsigned">Document Inbox</a>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="variant === ' vertical-style-2'">
    <navbar-vertical-style-2></navbar-vertical-style-2>
</ng-container>